import React from 'react'
import Grid from '@material-ui/core/Grid/Grid'
import Paper from '@material-ui/core/Paper/Paper'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography } from '@material-ui/core'
import ButtonLink from '../../ButtonLink'
import {
    IconUpdate,
    Person1,
    IconStars,
    IconStore,
    IconNextweeek,
} from '../../Icons'

const iconColors = [
    { icon1: Person1, iconBg: '#cc0099' },
    { icon1: IconStars, iconBg: '#009933' },
    { icon1: IconStore, iconBg: '#3399ff' },
    { icon1: IconNextweeek, iconBg: '#ff3333' },
]

const styles = theme => ({
    grid: {
        paddingLeft: 20,
        paddingRight: 20,
    },
    mycard: {
        padding: theme.spacing.unit * 2,
        marginTop: 60,
        paddingBottom: 4,
    },
    cardIcon: {
        display: 'inline-block',
        marginTop: -40,
        padding: 20,
        borderRadius: 4,
    },
    gridBottomBorder: {
        paddingBottom: 6,
        marginBottom: 6,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#ddd',
    },
})
const FirstRow = ({ data, classes }) => (
    <Grid
        /* style={{backgroundColor: '#ccc'}} */
        direction="row"
        justify="space-around"
        container
    >
        {data.map((data, index) => (
            <MyCard key={index} tower={iconColors[index]} data={data} classes={classes} />
        ))}
    </Grid>
)
export default withStyles(styles)(FirstRow)

const MyCard = ({ classes, data, tower }) => (
    <Grid className={classes.grid} xs={12} sm={6} md={3} lg={3} item>
        <Paper className={classes.mycard}>
            <Grid
                className={classes.gridBottomBorder}
                container
                direction="row"
            >
                <Grid item>
                    <Paper className={classes.cardIcon} style={{backgroundColor: `${tower.iconBg}`}}>
                        <tower.icon1 />
                    </Paper>
                </Grid>
                <Grid style={{ marginLeft: 'auto' }} item>
                    <Typography variant="body1" color="textSecondary">
                        {data.label}
                    </Typography>
                    <Typography variant="h5">{data.value}</Typography>
                </Grid>
            </Grid>
            <Grid container direction="row" justify="space-between">
                <Grid item>
                    <ButtonLink label="View" />
                </Grid>

                <Grid item>
                    <Grid container direction="row">
                        <IconUpdate />
                        <Typography variant="caption" color="textSecondary">
                            {data.updateDt}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    </Grid>
)
